import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import { api } from '../../app/Api/ApiSlice';
// import "../projects/projects.css";
import "./storesStyles.css";
import { FaTimes } from 'react-icons/fa';

const AddProduct = () => {
    const [files, setFiles] = useState([]);
    const [productName, setProductName] = useState("");
    const [description, setDescription] = useState("");
    const [price, setPrice] = useState("");
    const [selectedShelves, setSelectedShelves] = useState([]);
    const [stock, setStock] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [imagePreviews, setImagePreviews] = useState([]);
    const [shelves, setShelves] = useState([]);
    const [openCreateShelf, setOpenCreateShelf] = useState(false);

    //new shelf
    const [shelfName, setShelfName] = useState("")
    const [shelfDescription, setShelfDescription] = useState("")
    const [creating, setCreating] = useState(false)

    const navigate = useNavigate();
    const { name } = useParams(); // Correct usage

    // Handle file uploads
    const addFiles = (e) => {
        const selectedFiles = Array.from(e.target.files);
        setFiles(selectedFiles);

        const previews = selectedFiles.map(file => URL.createObjectURL(file));
        setImagePreviews(previews);
    };

    // Cleanup object URLs to prevent memory leaks
    useEffect(() => {
        return () => {
            imagePreviews.forEach(url => URL.revokeObjectURL(url));
        };
    }, [imagePreviews]);

    // Remove selected file
    const handleRemove = (index) => {
        setFiles(prev => prev.filter((_, i) => i !== index));
        setImagePreviews(prev => prev.filter((_, i) => i !== index));
    };

    // Fetch shelves
    useEffect(() => {
        const getShelves = async () => {
            try {
                const response = await api.get(`/stores/${name}/manage/product/shelves`);
                if (response?.data) {
                    setShelves(response.data);
                    console.log(response)
                }
            } catch (error) {
                console.error("Error fetching shelves", error);
            }
        };

        getShelves();
    }, [name]);

    const uploadToS3 = async (file) => {
        const presignRes = await api.post("/uploads/presign", {
            filename: file.name,
            contentType: file.type,
        })

        const { uploadUrl, key } = presignRes.data

        const res = await fetch(uploadUrl, {
            method: "PUT",
            headers: {
                "Content-Type": file.type,
            },
            body: file,
        })

        if (!res.ok) {
            throw new Error(`Upload failed: ${file.name}`)
        }

        const baseType = file.type.split("/")[0]

        return {
            key,
            type:
                baseType === "image"
                    ? "image"
                    : baseType === "video"
                        ? "video"
                        : "document",
            mimeType: file.type,
            name: file.name,
            size: file.size,
        }
    }


    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!productName || !price || !stock) {
            toast.warn("Please fill in all required fields");
            return;
        }

        try {
            setIsLoading(true);

            // 1. Wait for all files to upload to S3
            const uploadPromises = files.map((f) => uploadToS3(f));
            const uploadedFilesMetadata = await Promise.all(uploadPromises);

            // 2. Construct the product object with the resolved file data
            const newProduct = {
                title:productName,
                description,
                price,
                shelves:selectedShelves,
                stock,
                files: uploadedFilesMetadata, // Now contains the keys and types
            };

            // 3. Send to your backend
            await api.post(`/stores/${name}/manage/products`, newProduct);

            toast.success("Product created successfully!");
            navigate(`/b/manage/${name}/products`);
        } catch (error) {
            toast.error(error.response?.data?.message || "An error occurred during upload");
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    const handleCreateShelf = async (e) => {
        e.preventDefault()

        const newShelf = { name: shelfName, description: shelfDescription }
        try {
            setCreating(true)
            const response = await api.post(`stores/${name}/manage/shelves`, { newShelf })
            if (response) {
                setShelves((prev) => [...prev, response.data])
                toast.success("shelf created")
                setShelfName("")
                setShelfDescription("")
                setOpenCreateShelf(false)
            }
        } catch (error) {
            toast.error(error.response.data.message)
        }
        finally {
            setCreating(false)
        }
    }

    return (
        <div>
            <div className={openCreateShelf ? "open-create-shelf-modal" : "close-create-shelf-modal"}>
                <form onSubmit={handleCreateShelf}>
                    <div className='create-shelf-btn-wrapper' >
                        <button onClick={() => setOpenCreateShelf(!openCreateShelf)} className="close-create-shelf">
                            <FaTimes />
                        </button>
                    </div>
                    <h3 className="modal-title">Create New Shelf</h3>
                    <label htmlFor="name">Name</label>
                    <input
                        type="text"
                        required={true}
                        placeholder='products shelf name'
                        onChange={(e) => setShelfName(e.target.value)}
                    />
                    <label htmlFor="description">Description</label>
                    <input
                        type="text"
                        required={true}
                        placeholder='Shelf description'
                        onChange={(e) => setShelfDescription(e.target.value)}
                    />
                    <button>{creating ? "Loading..." : "Save"}</button>
                </form>
            </div>

            <div className="form-wrapper">
                <h2 className="event-form-title">Create A New Product</h2>
                <form className="project-form" onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
                    <label>Product Name</label>
                    <input
                        type="text"
                        placeholder="Enter the product name"
                        value={productName}
                        onChange={(e) => setProductName(e.target.value)}
                    />

                    <label>Description</label>
                    <input
                        type="text"
                        className="event-description"
                        placeholder="Describe the product"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                    />

                    <label>Price</label>
                    <input
                        type="number"
                        placeholder="Enter product price"
                        value={price}
                        onChange={(e) => setPrice(Number(e.target.value))}
                    />

                    <label>Shelves</label>
                    <p onClick={() => setOpenCreateShelf(true)} className="clickable-text">
                        Create a shelf
                    </p>
                    <select
                        multiple
                        value={selectedShelves}
                        onChange={(e) =>
                            setSelectedShelves(Array.from(e.target.selectedOptions, option => option.value))
                        }
                        className="shelves-add-select"
                    >
                        {shelves.map((shelf) => (
                            <option key={shelf._id} value={shelf._id}>
                                {shelf.name}
                            </option>
                        ))}
                    </select>
                    <label>Stock</label>
                    <input
                        type="number"
                        placeholder="Enter stock quantity"
                        value={stock}
                        onChange={(e) => setStock(e.target.value)}
                    />

                    <label>Upload Images</label>
                    <input type="file" onChange={addFiles} multiple />

                    {imagePreviews.length > 0 && (
                        <div className="images-preview">
                            {imagePreviews.map((preview, i) => (
                                <div key={i} className="form-image">
                                    <img src={preview} alt={`Preview ${i}`} className="image-preview" />
                                    <div className="remove-img">
                                        <button type="button" onClick={() => handleRemove(i)}>
                                            Remove
                                        </button>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div className="post-form-btn">
                        <button type="submit" disabled={isLoading}>
                            {isLoading ? "Loading..." : "Save"}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default AddProduct;
